import type { StorageLike } from 'pinia-plugin-persistedstate'

import { appErrorService } from '@/services/AppErrorService'

/**
 * Storage for `pinia-plugin-persistedstate` that reports a rejected write (e.g. Safari's 5 MB quota)
 * before the plugin handles it. The plugin only logs to the console, which is how the catalog store
 * failed to persist unnoticed. Reported once per store key for the storage's lifetime, one page load
 * in production: the store is rewritten on every mutation.
 */
export function createReportingStorage(storage: Storage = localStorage): StorageLike {
  const reportedStorageKeys = new Set<string>()

  return {
    getItem: (key: string): string | null => storage.getItem(key),
    setItem: (key: string, value: string): void => {
      try {
        storage.setItem(key, value)
      } catch (error) {
        if (!reportedStorageKeys.has(key)) {
          reportedStorageKeys.add(key)
          appErrorService.reportError(error, {
            context: 'persistedState.setItem',
            storeKey: key,
            payloadLength: value.length
          })
        }
        throw error
      }
    }
  }
}
